<div class="notification" [@fadeInOut]>
    <div class="notification-header">
        <h3 class="notification-title">{{ data.Contenido.Titulo }}</h3>
        <i class="fa fa-times notification-close" (click)="close()"></i>
    </div>
    <div class="notification-container">
        <div class="notification-media">
            <img src="{{data.Contenido.AvatarUrl}}" alt=""
                class="notification-user-avatar" />
            <i class="{{data.Contenido.Icono}} notification-reaction"></i>
        </div>
        <div class="notification-content">
            <p class="notification-text">
                {{ data.Contenido.Mensaje }}
            </p>
            <span class="notification-timer">{{ getTimeAgo(fecha) }}</span>
        </div>
        <span class="notification-status"></span>
    </div>
</div>